var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73096 41.5L24 6.5L44.269 41.5H3.73096ZM7.66146 39.2305H40.3385L24 11.0385L7.66146 39.2305ZM24.1515 36.227C24.5081 36.227 24.8041 36.1063 25.0395 35.865C25.2748 35.6237 25.3925 35.3247 25.3925 34.968C25.3925 34.611 25.2718 34.315 25.0305 34.08C24.7891 33.8447 24.49 33.727 24.133 33.727C23.7763 33.727 23.4803 33.8477 23.245 34.089C23.01 34.3303 22.8925 34.6293 22.8925 34.986C22.8925 35.3427 23.0131 35.6387 23.2545 35.874C23.4958 36.1093 23.7948 36.227 24.1515 36.227ZM23.0075 31.331H25.277V20.4385H23.0075V31.331Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c2223c6aab793232b099a7c53cb92934.svg";
export { ForwardRef as ReactComponent };